import { createFileRoute } from '@tanstack/react-router';

import { AccessPage } from '@/pages/settings/roles/AccessPage';

export const Route = createFileRoute('/_authenticated/_app/settings/access')({
	component: AccessPage,
});
